import { LicenceComponentType } from '../Types/licence-component-type.type';
import { LicenceState } from '../Types/licence-state.type';

export const MIN_LICENCE_QUANTITY = 1;

export const ASSIGNABLE_USERS_PAGE_SIZE = 200;

export const LICENCE_ROSTER_COLUMNS = [
    'index',
    'component',
    'holder',
    'email',
    'assigned',
    'status',
    'action',
];

export const LICENCE_COMPONENT_LABEL_KEYS: Record<LicenceComponentType, string> = {
    seat: 'app.billing.estimate.lines.seat',
    agent: 'app.billing.estimate.lines.agent',
};

export const LICENCE_STATE_CLASSES: Record<LicenceState, string> = {
    licensed: 'paid',
    unlicensed: 'void',
    ending: 'open',
};
